import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  connect() {
    this.tooltipInstances = []
    this.initTooltips()
    // Turbo-фрейми/стріми можуть додавати нові тригери після connect, тож стежимо за DOM.
    // ВАЖЛИВО: лише ДОДАЄМО тултипи новим тригерам і прибираємо ті, чий елемент уже
    // вилучено з DOM. Раніше тут був refresh (dispose-all + reinit-all) на КОЖНУ мутацію —
    // він тер щойно показаний тултип: Bootstrap додає tip-вузол у <body> → це мутація →
    // teardown активної підказки, тож тултипи фактично не встигали зʼявитися.
    this.observer = new MutationObserver(() => this.syncTooltips())
    this.observer.observe(document.body, { childList: true, subtree: true })
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    this.disposeTooltips()
  }

  initTooltips() {
    const els = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    els.forEach(el => {
      if (!el._tooltipInstance) {
        // animation: false робить executeAfterTransition синхронним — відкладений
        // fallback-таймер не планується, тож жоден колбек (show/hide → _isWithActiveTrigger)
        // не переживе dispose() під час Turbo-навігації з активним наведенням.
        // Це структурно усуває TypeError «Cannot convert undefined or null to object» (F4).
        const instance = new bootstrap.Tooltip(el, { animation: false })
        el._tooltipInstance = instance
        this.tooltipInstances.push(instance)
      }
    })
  }

  // Ідемпотентна реакція на мутації DOM: прибрати тултипи вилучених елементів
  // (напр. після turbo-frame swap) і додати новим тригерам. Активні тултипи не чіпаємо.
  syncTooltips() {
    this.tooltipInstances = this.tooltipInstances.filter(instance => {
      if (instance && instance._element && !document.body.contains(instance._element)) {
        instance._element._tooltipInstance = null
        instance.dispose()
        return false
      }
      return true
    })
    this.initTooltips()
  }

  disposeTooltips() {
    this.tooltipInstances.forEach(instance => {
      // Під час Turbo-навігації елемент може бути прибраний до того, як спрацює
      // disconnect. Повторний dispose на вже звільненому instance читав би
      // instance._element.closest → null-помилка.
      if (instance && instance._element) {
        instance._element._tooltipInstance = null
        instance.dispose()
      }
    })
    this.tooltipInstances = []
  }
}
